__turbopack_context__.v({
  "root": "hero-content-module-scss-module__mXcX1a__root",
});
